"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultNavigationCard = ResultNavigationCard;
const jsx_runtime_1 = require("react/jsx-runtime");
const client_1 = require("@kalkulacka-one/design-system/client");
const next_intl_1 = require("next-intl");
const navigation_card_1 = require("./navigation-card");
const HEIGHT = "koa:h-[88px]";
function ResultNavigationCard({ onNextClick, onShareClick }) {
    const t = (0, next_intl_1.useTranslations)("koa.components.resultNavigationCard");
    return ((0, jsx_runtime_1.jsx)(navigation_card_1.NavigationCard, { children: (0, jsx_runtime_1.jsxs)("div", { className: "koa:flex koa:gap-2 koa:w-full", children: [(0, jsx_runtime_1.jsx)("div", { className: "koa:flex-1", children: (0, jsx_runtime_1.jsx)(client_1.Button, { color: "neutral", variant: "outline", onClick: onNextClick, children: t("compareButton") }) }), (0, jsx_runtime_1.jsx)("div", { className: "koa:flex-1", children: (0, jsx_runtime_1.jsx)(client_1.Button, { color: "neutral", variant: "fill", onClick: onShareClick, children: t("shareButton") }) })] }) }));
}
ResultNavigationCard.heightClassNames = HEIGHT;
